import { notification } from 'antd'
import {
  // getAbstractDashActivityUrl,
  getAbstractDashSingleUrl,
  getAbstractDashNoteCountUrl,
  listAbstractDashNotesUrl,
  deleteAbstractDashNoteUrl,
  updateAbstractDashStatusUrl,
  addAbstractViewNoteUrl,
  AbstractViewNotesUrl,
  DeleteAbstractViewUrl,
  WithdrawalAbstractUrl,
  AbstractlistActivityUrl,
  allAbstractUrl,
  addReviewerInAbstractUrl,
  processAbstractPaymentUrl,
  sendAbstractCommentsUrl,
  sendAbstractReceiveDateUrl,
  commentsToAbstractAuthorUrl,
  ResendAbstractUrl,
  ResendAbstractCommentsURL,
  RevisedAbstractURL,
  editAbstractReceiveDateUrl,
  ApproveAbstractURL,
  AcceptanceAbstractURL,
  AddDoiAbstractUrl,
  viewGeneratedAbstractXmlUrl,
  generateAndDepositAbstractXmlUrl,
  OnlinePublishAbstractURL
} from '../apis'
import { getToken, customAxios as axios } from '../../../../request'
import { hidePageLoad, showPageLoad } from '../../../../modules/actions'
import { showProgressPageLoad, hideProgressPageLoad } from '../../../../modules/actions'
import { listAbstractActivityUrl, listAbstractNotesUrl } from '../../apis'

/**
 * FETCH SINGLE ABSTRACT SNAPSHOT
 */
export const getSingleAbstractAction = (id) => async (dispatch) => {
  let config = { ...getToken() };
  try {
    let { data } = await axios.get(getAbstractDashSingleUrl(id), config);
    if (data.error) {
      notification.error({ message: data.message || 'Error loading data' });
    }
    return data;
  } catch (error) {
    return { success: false, error: true };
  }
};

/**
 * FETCH ACTIVITY LOGS (The "Cycle")
 */
// export const getAbstractActivityAction = (abstractId) => async (dispatch) => {
//   let config = { ...getToken() };
//   try {
//     let { data } = await axios.get(getAbstractDashActivityUrl(abstractId), config);
//     return data;
//   } catch (error) {
//     return { success: false, data: [] };
//   }
// };

/**
 * FETCH NOTE COUNT
 */
export const abstractNoteCountFxn = async (query) => {
  let config = { params: { ...query }, ...getToken() };
  try {
    let { data } = await axios.get(getAbstractDashNoteCountUrl(query.abstractId), config);
    return data;
  } catch (error) {
    return { data: 0 };
  }
};

/**
 * LIST INTERNAL NOTES
 */
export const listAbstractNotesFxn = async (query) => {
  let config = { params: { ...query }, ...getToken() };
  try {
    let { data } = await axios.get(listAbstractDashNotesUrl(), config);
    return data;
  } catch (error) {
    return { data: [] };
  }
};

/**
 * DELETE NOTE
 */
export const deleteAbstractNoteFxn = async (id) => {
  let config = { ...getToken() };
  try {
    let { data } = await axios.post(deleteAbstractDashNoteUrl(), { noteId: id }, config);
    return data;
  } catch (error) {
    return { success: false, error: true };
  }
};

/**
 * UPDATE STATUS
 */
export const updateAbstractStatusFxn = (valData) => async (dispatch) => {
  dispatch(showPageLoad());
  let config = { ...getToken() };
  try {
    let { data } = await axios.post(updateAbstractDashStatusUrl(), valData, config);
    dispatch(hidePageLoad());
    if (data.success) {
      notification.success({ message: 'Status updated successfully' });
    } else {
      notification.error({ message: data.message || 'Update failed' });
    }
    return data;
  } catch (error) {
    dispatch(hidePageLoad());
    return { success: false, error: true };
  }
};
export const addAbstractViewNoteFxn = async (valData) => {
  let config = {
    ...getToken()
  };

  try {
    let { data } = await axios.post(addAbstractViewNoteUrl(), valData, config);

    if (data.error) {
      notification.error({
        message: data.message || 'Error adding note'
      });
    }

    return data;
  } catch (error) {
    notification.error({
      message: 'Server error while adding note'
    });
    return { success: false, error: true };
  }
};
export const AbstractViewNotesFxn = async (query) => {
  let config = {
    params: { ...query },
    ...getToken()
  };

  try {
    let { data } = await axios.get(AbstractViewNotesUrl(), config);
    return data;
  } catch (error) {
    console.error("Error fetching notes:", error);
    return [];
  }
};
export const DeleteAbstractViewFxn = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.put(DeleteAbstractViewUrl(), valData, getToken())
  dispatch(hidePageLoad())

  if (data.error) {
    notification.error({
      message: data.message || 'Error deleting abstract'
    })
  } else {
    notification.success({
      message: data.message || 'Abstract deleted successfully'
    })
  }
  return data
}

export const WithdrawalAbstractFxn = (obj) => async (dispatch) => {
  dispatch(showPageLoad()); // This turns on the loader
  try {
    let { data } = await axios.post(WithdrawalAbstractUrl(), obj, getToken());
    dispatch(hidePageLoad());
    return data;
  } catch (error) {
    dispatch(hidePageLoad());
    return { success: false };
  }
};
export const getNotesWithCountFxn = async (query) => {
  const config = { params: { ...query }, ...getToken() };
  try {
    // 1. Fetch the List
    const listResp = await axios.get(listAbstractDashNotesUrl(), config);
    const countResp = await axios.get(getAbstractDashNoteCountUrl(query.abstractId), config);

    return {
      success: true,
      list: listResp.data || [],
      count: countResp.data.count || 0
    };
  } catch (error) {
    console.error("Error fetching notes:", error);
    return { success: false, list: [], count: 0 };
  }
};
// export const AbstractlistActivityFxn = (query) => async (dispatch) => {
//   let config = {
//     params: { ...query },
//     ...getToken()
//   };
//
//   try {
//     let { data } = await axios.get(AbstractlistActivityUrl(), config);
//
//     if (data.error) {
//       notification.error({
//         message: data.message || 'Error fetching history'
//       });
//     }
//
//     return data;
//   } catch (error) {
//     console.error("Error fetching abstract history:", error);
//     notification.error({
//       message: 'Server error while fetching history'
//     });
//     return { success: false, data: [] };
//   }
// };
export const AbstractlistActivityFxn = async (query) => {
  let config = {
    params: { ...query },
    ...getToken()
  };

  try {
    let { data } = await axios.get(AbstractlistActivityUrl(), config);
    if (data.error) {
      notification.error({ message: data.message || 'Error fetching history' });
    }
    return data; // This will now return the DATA, not the function
  } catch (error) {
    return { success: false, data: [] };
  }
};
export const getAllAbstracts = filters => async dispatch => {
  dispatch(showPageLoad())

  let config = {
    params: { ...filters },
    ...getToken()
  }

  try {
    let { data } = await axios.get(allAbstractUrl(), config)
    dispatch(hidePageLoad())
    return data
  } catch (error) {
    dispatch(hidePageLoad())
    // Optional: handle error here if needed
    console.error("Error fetching abstracts:", error)
    return { total: 0, list: [] }
  }
}
export const addReviewerInAbstract = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(
    addReviewerInAbstractUrl(),
    valData,
    getToken()
  )
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  }
  return data
}
export const processAbstractPaymentApi = (valData) => async (dispatch) => {
  dispatch(showPageLoad());

  try {
    let { data } = await axios.post(processAbstractPaymentUrl(), valData, getToken());

    dispatch(hidePageLoad());

    if (data && data.error) {
      notification.error({
        message: data.message || 'Error processing payment'
      });
    } else {
      notification.success({
        message: data.message || 'Payment added successfully'
      });
    }

    return data;
  } catch (error) {
    dispatch(hidePageLoad());
    notification.error({
      message: 'Server error while processing payment'
    });
    return { success: false, message: 'Server error' };
  }
};
export const SendAbstractComments = valData => async dispatch => {
  dispatch(showPageLoad());

  try {
    let { data } = await axios.post(sendAbstractCommentsUrl(), valData, getToken());

    dispatch(hidePageLoad());

    if (data.error) {
      notification.error({
        message: data.message || 'Error saving abstract remarks'
      });
    } else {
      notification.success({
        message: 'Remarks saved successfully'
      });
    }

    return data;
  } catch (error) {
    dispatch(hidePageLoad());
    notification.error({ message: 'Server error' });
    return { success: false };
  }
};
export const SendAbstractReceiveDate = (valdata) => async (dispatch) => {
  dispatch(showPageLoad());
  let { data } = await axios.post(sendAbstractReceiveDateUrl(), valdata, getToken());

  dispatch(hidePageLoad());

  if (data.error) {
    notification.error({
      message: data.message || 'Error updating receive date'
    });
  } else {
    notification.success({
      message: 'Receive date updated successfully'
    });
  }
  return data;
};
export const commentToAbstractAuthor = valData => async dispatch => {
  dispatch(showPageLoad())
  try {
    let { data } = await axios.post(commentsToAbstractAuthorUrl(), valData, getToken())
    dispatch(hidePageLoad())

    if (data.error) {
      notification.error({
        message: data.message || 'Error sending comments to author'
      })
    } else {
      notification.success({
        message: data.message || 'Comments sent successfully'
      })
    }
    return data
  } catch (error) {
    dispatch(hidePageLoad())
    notification.error({
      message: 'Server error while sending comments'
    })
    return { success: false }
  }
}
export const ResendAbstract = valdata => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(ResendAbstractUrl(), valdata, getToken())

  dispatch(hidePageLoad())

  if (data.error) {
    notification.error({
      message: data.message || 'Error Resending Abstract'
    })
  } else {
    notification.success({
      message: data.message || 'Abstract Resent Successfully'
    })
  }

  return data
}
export const ResendAbstractComments = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(ResendAbstractCommentsURL(), valData, getToken())

  dispatch(hidePageLoad())

  if (data.error) {
    notification.error({
      message: data.message || 'Error resending comments'
    })
  } else {
    notification.success({
      message: data.message || 'Comments resent successfully'
    })
  }
  return data
}
export const RevisedAbstract = valdata => async dispatch => {
  dispatch(showPageLoad());
  let { data } = await axios.post(RevisedAbstractURL(), valdata, getToken());
  dispatch(hidePageLoad());

  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    });
  } else {
    notification.success({
      message: data.message || 'Success'
    });
  }
  return data;
};
export const UpdateAbstractReceiveDate = (valdata) => async (dispatch) => {
  dispatch(showPageLoad());
  try {
    let { data } = await axios.post(editAbstractReceiveDateUrl(), valdata, getToken());
    dispatch(hidePageLoad());

    if (data.error) {
      notification.error({
        message: data.message || 'Error updating receive date'
      });
    }
    return data;
  } catch (error) {
    dispatch(hidePageLoad());
    notification.error({
      message: 'Network Error'
    });
    return { error: true };
  }
};
export const ApproveAbstract = valData => async dispatch => {
  dispatch(showPageLoad())

  // Calls the new abstract endpoint
  let { data } = await axios.put(ApproveAbstractURL(), valData, getToken())

  dispatch(hidePageLoad())

  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  } else {
    notification.success({
      message: data.message || 'Email sent successfully'
    })
  }

  return data
}
export const AcceptanceAbstract = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.put(AcceptanceAbstractURL(), valData, getToken())
  dispatch(hidePageLoad())

  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  } else {
    notification.success({
      message: data.message || 'Success'
    })
  }
  return data
}
export const AddDoiAbstractFxn = valData => async dispatch => {
  dispatch(showProgressPageLoad())

  let { data } = await axios.post(AddDoiAbstractUrl(), valData, {
    onUploadProgress: progressEvent => {
      let percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      )
      dispatch({ type: 'PROGRESS_START', percentage: percentCompleted })
    },
    ...getToken()
  })

  dispatch(hideProgressPageLoad())
  dispatch({ type: 'PROGRESS_END' })

  if (data.error) {
    notification.error({
      message: data.message || 'Error updating Abstract'
    })
  }

  return data
}

export const viewGeneratedXml = valData => async dispatch => {
  dispatch(showPageLoad());
  try {
    let { data } = await axios.post(viewGeneratedAbstractXmlUrl(), valData, getToken());
    dispatch(hidePageLoad());
    if (data.error) {
      notification.error({
        message: data.message || 'Error viewing Abstract XML'
      });
    }
    return data;
  } catch (error) {
    dispatch(hidePageLoad());
    notification.error({ message: 'Server communication error' });
    return { success: false };
  }
};
export const generateAndDepositAbstractXml = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.post(
    generateAndDepositAbstractXmlUrl(),
    valData,
    getToken()
  )
  dispatch(hidePageLoad())
  if (data.error) {
    notification.error({ message: data.message || 'Error' })
  }
  return data
}
export const OnlinePublishAbstract = valData => async dispatch => {
  dispatch(showPageLoad())
  let { data } = await axios.put(OnlinePublishAbstractURL(), valData, getToken())
  dispatch(hidePageLoad())

  if (data.error) {
    notification.error({
      message: data.message || 'Error'
    })
  } else {
    notification.success({
      message: data.message || 'Success'
    })
  }
  return data
}

